import { Country } from '@prisma/client';
import { State } from 'country-state-city';

export const getStateName = (state: string, country?: string) => {
  if (!state) {
    return '-';
  }

  return (
    State.getStateByCodeAndCountry(state, country || Country.US)?.name || state
  );
};
